// eslint-disable-next-line
export default defineNuxtPlugin(nuxtApp => {
	return {};
});
